var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _g7, _rect7, _g8, _rect8, _g9, _g0, _g1, _g10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCollectionMixedLoadingWeb = function SvgCollectionMixedLoadingWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 1280 584"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 16h272v153H72z"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 72,
    y: 177,
    fill: "#1A1A1A",
    rx: 6
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M360 16h272v153H360z"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 360,
    y: 177,
    fill: "#1A1A1A",
    rx: 6
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 16h272v153H648z"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 648,
    y: 177,
    fill: "#1A1A1A",
    rx: 6
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M936 16h272v153H936z"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 936,
    y: 177,
    fill: "#1A1A1A",
    rx: 6
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 252h272v153H72z"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 72,
    y: 413,
    fill: "#1A1A1A",
    rx: 6
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M360 252h272v153H360z"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 360,
    y: 413,
    fill: "#1A1A1A",
    rx: 6
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 252h272v153H648z"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 648,
    y: 413,
    fill: "#1A1A1A",
    rx: 6
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M936 252h272v153H936z"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 173.617,
    height: 12,
    x: 936,
    y: 413,
    fill: "#1A1A1A",
    rx: 6
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M72 488h272v153H72z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M360 488h272v153H360z"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M648 488h272v153H648z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#l)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M936 488h272v153H936z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 72,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 360,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 648,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 936,
    y: 16,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 72,
    y: 252,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 360,
    y: 252,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 648,
    y: 252,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 936,
    y: 252,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 72,
    y: 488,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 360,
    y: 488,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 648,
    y: 488,
    fill: "#fff",
    rx: 4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 272,
    height: 153,
    x: 936,
    y: 488,
    fill: "#fff",
    rx: 4
  })))));
};
export default SvgCollectionMixedLoadingWeb;